import { useNavigate } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4 px-8">
      <div className="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center">
        <FileQuestion className="w-8 h-8 text-slate-400" />
      </div>
      <div className="text-center">
        <h1 className="text-lg font-semibold text-slate-900 mb-1">Page not found</h1>
        <p className="text-sm text-slate-500">The page you're looking for doesn't exist.</p>
      </div>
      <Button variant="secondary" onClick={() => navigate('/')}>
        Back to home
      </Button>
    </div>
  );
}
